module.exports = __webpack_public_path__ + "img/status-success.0aaa6e99.svg";